import { Navbar } from "@mantine/core";
import React from "react";

function Sidebar({ children }: { children: React.ReactNode }) {
  return (
    <Navbar
      p="md"
      classNames={{
        root: "md:sticky",
      }}
    >
      <Navbar.Section grow>{children}</Navbar.Section>
    </Navbar>
  );
}

export default Sidebar;
